<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row mb-5">
            <div class="col-12">
                <label class="mb-4 ml-3 h5 text-uppercase">
                    Datos del responsable 1
                </label>
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Nombre del responsable" type="text" name="nombre_responsable" id="nombre_responsable" rules="required" v-model="base_data.nombre_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Apellidos del responsable" type="text" name="apellidos_responsable" id="apellidos_responsable" rules="required" v-model="base_data.apellidos_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="DNI del responsable" type="text" name="dni_responsable" id="dni_responsable" rules="" v-model="base_data.dni_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Teléfono del responsable" type="number" name="telefono_responsable" id="telefono_responsable" rules="required" v-model="base_data.telefono_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Email del responsable" type="email" name="email_responsable" id="email_responsable" rules="required" v-model="base_data.email_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 pr-5 mb-5" v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" :class="'col-12 mt-3' + (field.type === 'textarea' ? ' col-lg-12' : '')">
                        <FieldComponent
                            :field="field"
                            :desactivar="!paso_activo"
                            v-model="fields_responsable_1[field.name]"
                        />
                    </div>
                </div>
                <div class="col-12">
                    <label class="mb-4 h5 text-uppercase">
                        Datos del responsable 2
                    </label>    
                </div>
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Nombre del responsable 2" type="text" name="nombre_responsable_2" id="nombre_responsable_2" rules="" v-model="base_data.nombre_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Apellidos del responsable 2" type="text" name="apellidos_responsable_2" id="apellidos_responsable_2" rules="" v-model="base_data.apellidos_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="DNI del responsable 2" type="text" name="dni_responsable_2" id="dni_responsable_2" rules="" v-model="base_data.dni_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Teléfono del responsable 2" type="number" name="telefono_responsable_2" id="telefono_responsable_2" rules="" v-model="base_data.telefono_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4 mb-4">
                    <FormInput style="width: 98%; margin: auto" label="Email del responsable 2" type="email" name="email_responsable_2" id="email_responsable_2" rules="" v-model="base_data.email_responsable_2" :disabled="!paso_activo" />
                </div>
                <br />
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Observaciones" type="text" name="observaciones" id="observaciones" rules="" v-model="base_data.observaciones" :disabled="!paso_activo" />
                </div>
                <div class="col-12 pr-5" v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" :class="'col-12 mt-3' + (field.type === 'textarea' ? ' col-lg-12' : '')">
                        <FieldComponent
                            :field="field"
                            :desactivar="!paso_activo"
                            v-model="fields_responsable_2[field.name]"
                        />
                    </div>
                </div>
                <div class="col-12 text-right mt-4">
                    <Button @click="volver()" name="button" class="mr-2" :disabled="!paso_activo">ATRÁS</Button>
                    <Button id="terminar-paso-2" type="submit" name="button" :disabled="!paso_activo">CONTINUAR</Button>
                </div>
            </div>
        </div>
    </ValidationObserver>    
</template>

<script>
    import FieldComponent from '@/components/common/FieldComponent';
    export default {
        props: ["base", "paso_activo"],
        data() {
            return {
                base_data : {},
                fields_responsable_1: {},
                fields_responsable_2: {},
                lista_id: this.$route.params.lista_id
            };
        },
        created() {
            this.base_data = this.base;
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            fields() {
                return this.$store.getters.getListaAbonados.basesFields.filter(field => field.representante === true);
            }
        },
        methods: {
            terminar() {
                let params = {
                    base: this.base_data,
                    lista_id: this.lista_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-datos'), params).then(res => {
                    this.base_data.session_id = res.data.session_id;
                });

                this.base_data.fields_responsable_1 = Object.keys(this.fields_responsable_1).map(key => {
                    return {
                        name: key,
                        value: this.fields_responsable_1[key]
                    };
                });

                this.base_data.fields_responsable_2 = Object.keys(this.fields_responsable_2).map(key => {
                    return {
                        name: key,
                        value: this.fields_responsable_2[key]
                    };
                });

                this.$emit("guardarBase", this.base_data);
                this.$emit('terminado');
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            volver() {
                this.$emit("guardarBase", this.base_data);
                this.$emit('volver');
            }
        },
        components : { FieldComponent }
    };
</script>